export default "__VITE_ASSET__B7tEmdZ9__"